export enum StatusType {
    New = 0,
    InProcess = 4,
    Meeting = 7,
    Closed = 9,
    NotClosed = 10,
    NotGood = 11,

};